// A single yellow ring drawn at a hex's position. Uses elevation-aware Y
// so the ring sits flush on extruded terrain instead of the old flat offset.
import { useMemo } from 'react';
import * as THREE from 'three';
import { HEX_SIZE } from './HexGrid.js';

interface SelectionRingProps {
  readonly position: readonly [number, number, number];
  readonly surfaceY?: number;
}

export function SelectionRing({ position, surfaceY = 0.1 }: SelectionRingProps) {
  const geom = useMemo(() => new THREE.RingGeometry(HEX_SIZE * 0.85, HEX_SIZE * 0.95, 6), []);
  const y = surfaceY + 0.03;
  return (
    <mesh
      rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      position={[position[0], y, position[2]]}
      geometry={geom}
    >
      <meshBasicMaterial color="#ffd966" side={THREE.DoubleSide} />
    </mesh>
  );
}
